import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';

import { useIntl } from 'ha/i18n';
import * as SearchFilters from 'ha/types/SearchFilters';
import { CanonicalCollections } from 'ha/constants/SearchPageCollections';

interface Props {
  total: number;
  canonicalCollection: SearchFilters.CanonicalCollection;
  placeName: string;
  isSearchByPartner: boolean;
}

const useStyles = makeStyles({
  title: {
    margin: 0,
  },
});

export const SearchLocationTitle: React.FC<Props> = ({
  placeName,
  total,
  canonicalCollection,
  isSearchByPartner,
}) => {
  const { T } = useIntl();
  const classes = useStyles();

  const params = {
    placeName,
    total,
    kinds: {
      [CanonicalCollections.ApartmentForRent]: T(
        'seo_search_kinds_apartment_for_rent',
      ),
      [CanonicalCollections.PrivateRoomForRent]: T(
        'seo_search_kinds_private_room_for_rent',
      ),
      [CanonicalCollections.SharedRoomForRent]: T(
        'seo_search_kinds_shared_room_for_rent',
      ),
      [CanonicalCollections.StudioForRent]: T(
        'seo_search_kinds_studio_for_rent',
      ),
      [CanonicalCollections.CheapAccommodation]: T(
        'seo_search_kinds_cheap_accommodation',
      ),
      [CanonicalCollections.FurnishedApartments]: T(
        'seo_search_kinds_furnished_apartments',
      ),
      [CanonicalCollections.StudentAccommodation]: T(
        'seo_search_kinds_student_accommodation',
      ),
      [CanonicalCollections.LongTermRentals]: T(
        'seo_search_kinds_long_term_rentals',
      ),
      [CanonicalCollections.OneBedroomApartments]: T(
        'seo_search_kinds_one_bedroom_apartments',
      ),
      [CanonicalCollections.TwoBedroomApartments]: T(
        'seo_search_kinds_two_bedroom_apartments',
      ),
      [CanonicalCollections.StudentRoom]: T('seo_search_kinds_student_room'),
      '': T('seo_search_kinds'),
    }[canonicalCollection],
  };

  const localizedTitle = isSearchByPartner
    ? T('%(total)d %(kinds)s for rent near %(placeName)s', params)
    : T('%(total)d %(kinds)s for rent in %(placeName)s', params);

  return (
    <Typography variant="subtitle1" component="h1" className={classes.title}>
      {localizedTitle}
    </Typography>
  );
};

export default SearchLocationTitle;
